import { Component, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { GlobalJobordersService } from "src/app/_services/global-joborders.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "app-add-procedure",
    templateUrl: "./add-procedure.component.html",
    styleUrls: ["./add-procedure.component.scss"],
    standalone: false
})
export class AddProcedureComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  data: any;
  procedureList: any = [];
  selectedProcedure: any;
  isAddProcedureBtnClicked: boolean = false;
  selectedJOType: any;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private globalJOServc: GlobalJobordersService,
    private errorUtil: ErrorUtil,
    private bsModalServc: BsModalService,
    private globalJobordersService: GlobalJobordersService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    console.log("data in add procedure modal", this.data);
    this.getLanguageData();
    this.route.queryParams.subscribe((params) => {
      console.log(params, "params printing on route");
      this.selectedJOType = params.joTypeId;
    });
  }
  //Language
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.getProcedureList();
        }
      })
    );
    console.log("translate", this.translate);
  }

  push(obs: any) {
    super.push(obs);
  }

  getProcedureList() {
    this.globalJOServc.getProcedures().subscribe(
      (res: any) => {
        console.log(res, "res from get procedures api");
        this.procedureList = res;
      },
      (err: any) => {
        console.log(err, "error in GET procedures api");
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000
        );
      }
    );
    //getProcedures
  }

  onProcedureAdd() {
    this.isAddProcedureBtnClicked = true;
    if (!this.selectedProcedure) {
      return;
    } else {
      if (
        !this.data ||
        this.data.comingFrom == undefined ||
        this.data.comingFrom == null
      ) {
        this.bsModalServc.setDismissReason(
          JSON.stringify({ data: this.selectedProcedure })
        );
        this.modalRef.hide();
      }
      // else if (this.data.from == "jo-temp-task-standalone") {
      //   console.log(this.selectedProcedure,'selected procedure printing..')
      //   //add procedur in jo template view Task tab
      //}
      else {
        this.globalJobordersService
          .addProcedureToJobOrder(this.data.jobOrderId, this.selectedProcedure)
          .subscribe(
            (res: any) => {
              console.log(res, "res from add procedure to job order api");
              this.errorUtil.setErrorMessage(
                200,
                this.translate?.general.messages.savedSuccessfully,
                null,
                "success",
                2000
              );
              this.modalRef.hide();
            },
            (err: any) => {
              console.log(err, "error in add procedure to job order api");
              this.errorUtil.setErrorMessage(
                err.status,
                err.error ? err.error.title : null,
                err.error ? err.error.title : null,
                "error",
                2000
              );
            }
          );
      }
    }
  }

  addNewProcedure() {
    // open the create page in a new tab so the current modal stays open
    const urlTree = this.router.createUrlTree(
      ["/dashboard/setup/tasks/procedure/create"],
      {
        queryParams: {
          from: "add-procedure-jotemplate",
          joTypeId: this.selectedJOType,
        },
      }
    );
    const url = this.router.serializeUrl(urlTree);
    window.open(url, "_blank");
    //this.modalRef.hide();
  }

  onRefreshClick(){
    //to refresh the data after new procedure has been added
    this.getProcedureList();
  }
}
